'use strict';

import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextInput from 'Components/Forms/Elements/TextInput';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import LinkedInButton from 'Pure/LinkedInButton';
import GoogleButton from 'Pure/GoogleButton';
import Loader from 'Pure/Loader';
import Link from 'Pure/Link';
import removeGetParameter from 'Functions/removeGetParameter';
import bemit from 'Functions/bemit';
import { getUrlParameter } from 'Shared/utilities';
import { front_urls, URL, action } from 'Shared/Routes';
let app = window.app;
const qwest = window.qwest;
const DEFAULT_ERROR = 'Connexion impossible, veuillez rententer ' + 'ultérieurement.';
export default class LoginForm extends Component {
  state = {
    status_messages: {},
    email: '',
    password: '',
    error_code: getUrlParameter('error'),
    error: getUrlParameter('error') === 'login404' ? 'Aucun compte n\'existe pour cet email.' : undefined
  };
  handleChange = ({
    ...params
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    if (params.e === null && props['with-credentials']) {
      return; // prevent empty values on mount
    }

    handleChange.bind(this)({
      ...params
    });
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.error_code === 'login404' && props['allow-registration'] && typeof props.on3rdPartyLoginNotFound === 'function') {
      removeGetParameter('error');
      return props.on3rdPartyLoginNotFound();
    }
    const error = getUrlParameter('error');
    if (!error && app.state.form_error) {
      component.setState({
        error: app.state.form_error
      });
    }
    if (props['with-credentials'] && Array.isArray(props.credentials)) {
      const [login = '', password = ''] = props.credentials;
      component.setState({
        'email': login,
        'password': password
      });
    }
    if (error === 'login404') {
      return removeGetParameter('error');
    }
    if (error && props.source === 'CustomerLoginPage') {
      if (error === 'failed') {
        component.setState({
          error: 'Échec de la connexion.'
        });
      } else if (error === 'user_type') {
        component.setState({
          error: 'Le compte que vous avez utilisé n\'est pas ' + 'un compte client.'
        });
      }
      removeGetParameter('error');
    }
  }
  login = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
    e.persist();
    component.setState({
      loading: true
    });
    qwest.post(action('log-user'), {
      login: state.email,
      password: state.password
    }).then(function (xhr, response) {
      app.emit({
        event: 'TC_Click',
        source: 'LoginForm',
        data: {
          e: undefined,
          action: 'connexion'
        }
      });
      if (typeof props.onLogin === 'function') {
        component.setState({
          loading: false
        });
        return props.onLogin(response.user);
      }

      // Update user permissions now that user is connected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'login'
      });
      const role = response.user?.roles[0];
      if (role === "admin") {
        app.navigateTo(URL('AdminEtablishmentsDashboard', front_urls));
      } else if (role === "hotelier") {
        app.navigateTo(URL('AdminArrivalsDashboard', front_urls));
      } else if (role === "company") {
        app.navigateTo(URL('CompanyInformation', front_urls));
      } else if (role === "marketing") {
        app.navigateTo('/export-commandes-marketing');
      } else if (role === "customer" && window.location.pathname !== "/reserver-en-ligne") {
        app.navigateTo('/');
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response,
          error: DEFAULT_ERROR
        })
      });
    });
  };
  requestOAuthSignIn = (e, strategy) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      [strategy + '_redirecting']: true
    });
    window.setTimeout(function () {
      document.location.href = [document.location.origin, action('PassportAuth'), '?source=', props.source || 'LoginForm', '&strategy=' + strategy].join('');
    }, 320);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const login_bemit = ['front', 'blue', 'front-search'];
    if (props.source === 'CustomerLoginPage') {
      login_bemit.push('full-width');
    }
    let output = /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: "/login",
      className: "login-page__form",
      onSubmit: component.login
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['email'],
      name: "email",
      label: "E-mail",
      type: "email",
      autocomplete: "current-email",
      status: state.status_messages
    }), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['password'],
      name: "password",
      label: "Mot de passe",
      type: "password",
      className: "u-margin-top-10",
      autocomplete: "current-password",
      status: state.status_messages
    }), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-right u-margin-top-20"
    }, props.onForgottenPassword ? /*#__PURE__*/React.createElement(Button, {
      color: "secondary",
      size: "small",
      onClick: props.onForgottenPassword
    }, "Mot de passe oubli\xE9\xA0?") : /*#__PURE__*/React.createElement(Button, {
      color: "secondary",
      size: "small",
      href: URL('PasswordRecovery', front_urls),
      component: Link
    }, "Mot de passe oubli\xE9\xA0?")), status, /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-margin-top-25 u-text-center"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      className: bemit('c-flat-btn', login_bemit)
    }, "Je me connecte", loader)), props['with-google'] || props['with-linkedin'] ? /*#__PURE__*/React.createElement("div", {
      className: "c-separator c-separator--light\r u-margin-top-30 u-margin-bottom-30"
    }, "ou") : undefined, props['with-linkedin'] ? /*#__PURE__*/React.createElement(LinkedInButton, {
      onClick: e => component.requestOAuthSignIn(e, 'linkedin'),
      bemit: ['blue'],
      className: "u-full-width",
      loading: state.linkedin_redirecting
    }) : undefined, props['with-google'] ? /*#__PURE__*/React.createElement(GoogleButton, {
      onClick: e => component.requestOAuthSignIn(e, 'google'),
      className: "u-margin-top-20 u-full-width",
      loading: state.google_redirecting
    }) : undefined, props.children);
    return output;
  }
}
